// Route configuration
export const ROUTES = {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    VERIFY: '/verify',
    ACCOUNTS: '/home/accounts',
    SUBSCRIPTIONS: '/home/subscriptions',
    TERMINALS: '/home/terminals',
    ADDRESSES: '/home/addresses',
    USERS: '/home/users',
    DATAPOOL_CONSUMPTION: '/home/datapool-consumption',
    INVOICES: '/home/invoices',
    L2VPN_CIRCUITS: '/home/l2vpn-circuits',
    ACCOUNT_DETAILS_TAB: '/home/accounts/:organizationId/:tabSlug',
    SERVICE_LINE_DETAILS: '/home/service-lines/:serviceLineNumber',
    CUSTOMER_DETAILS_TAB: '/home/customers/:customerName/:tabSlug',
    CUSTOMER_SERVICE_LINE_DETAILS: '/home/customers/:customerName/service-lines/:serviceLineNumber',
    SLA: '/sla',
    USER_GUIDE: '/user-guide',
    HELP_CENTER: 'https://support.orbius.com/portal/en/home',
};